import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { parseRequestSchema } from '../../utils/parse-request-schema';
import { withJwt } from '../../utils/with-jwt';
import { routingProfileServiceEnvironment } from './routing-profile-service-environment';
import { routingProfileRequestSchema } from './schemas/request-schemas.schema';
import { RoutingProfile } from './schemas/routing-profile.schema';

export function putRoutingProfiles(routingProfile: Partial<RoutingProfile>) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${routingProfileServiceEnvironment.routingProfilesUrl}/${routingProfile.routingProfileId}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: parseRequestSchema(routingProfileRequestSchema, routingProfile),
        }
      )
    )
  ).pipe(ignoreData());
}
